import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { LlmTaskService } from './llm-task.service';

export const llmTaskServiceModule = angular.module('llmTaskServiceModule', [])
	.factory('llmTaskService', downgradeInjectable(LlmTaskService) as any)
	.name;
